import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AccountSelectorComponent } from '../shared/components/account-selector/account-selector.component';
import { LmsApi } from './_api/lms-api';

@Injectable({
  providedIn: 'root',
})
export class AccountSelectorService {
  constructor(private dialog: MatDialog) {}

  public async chooseAccounts(
    potentialAccounts: LmsApi.AuthenticateResponse[]
  ): Promise<LmsApi.AuthenticateResponse | undefined> {
    const dialogref = this.dialog.open<
      AccountSelectorComponent,
      LmsApi.AuthenticateResponse[],
      LmsApi.AuthenticateResponse
    >(AccountSelectorComponent, {
      disableClose: true,
      minWidth: '40%',
      maxWidth: '40%',
      data: potentialAccounts,
    });

    return new Promise((resolve) => {
      dialogref
        .afterClosed()
        .subscribe((selectedAccount?: LmsApi.AuthenticateResponse) => {
          resolve(selectedAccount);
        });
    });
  }
}
